import { React, useState, useEffect, useContext } from 'react'
import { CFormInput, CImage, CButton, CModal, CModalBody, CFormText } from '@coreui/react'
import { useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { CUSTOM_PAGES_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import DummyImg from '../../../assets/page-name-img.png'

const StaticPageNameModal = ({ pagesData = [], onCancel }) => {
  const history = useHistory()
  const { setLoader } = useContext(AppContext)
  const [pageTitle, setPageTitle] = useState('')
  const [pageUrl, setPageUrl] = useState('')
  const [errorMsg, setErrorMsg] = useState({})
  const limit = 70

  const [{ loading: createCustomPageLoading }, createCustomPageCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(createCustomPageLoading)
  }, [createCustomPageLoading])

  const titleChangeHandler = (newVal) => {
    setErrorMsg((prev) => ({ ...prev, pageTitle: '' }))
    setPageTitle(newVal.substring(0, limit))
  }

  const isValidUrl = (urlString) => {
    var urlPattern = new RegExp('^[A-Za-z0-9_-]+$')
    return !!urlPattern.test(urlString)
  }

  const validateInfo = () => {
    let errorObj = {}
    let isValid = true
    if (pageTitle.trim().length === 0) {
      errorObj.pageTitle = 'Project title cannot be Empty!'
      isValid = false
    }

    if (!isValidUrl(pageUrl)) {
      errorObj.pageUrl = 'Enter a Valid URL'
      isValid = false
    }

    if (pagesData.filter((info) => info.page_url === `/${pageUrl}`).length > 0) {
      errorObj.pageUrl = 'URL already exists!'
      isValid = false
    }
    setErrorMsg({ ...errorObj })

    return isValid
  }

  const onSaveHandler = async () => {
    if (!validateInfo()) return

    const createCustomPage = await createCustomPageCall({
      data: {
        name: pageTitle,
        page_url: `/${pageUrl}`,
        type: 'STATIC',
      },
    })

    if (createCustomPage?.data?.success) {
      history.push(`/static-editor/${createCustomPage?.data?.data?._id}`)
    }
  }

  return (
    <CModal size="xl" visible={true} alignment="center" className="page-title-preview border-0">
      <CModalBody
        className="m-auto p-0 rounded-sm"
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
        }}
      >
        <div
          className="d-flex flex-column justify-content-center align-items-start bg-white"
          style={{
            padding: '2rem 6rem 0 2rem',
          }}
        >
          <h4 className="font-bold text-black">Give a title to your Page</h4>
          <p className="text-secondary">
            <small style={{ fontSize: '.75rem' }}>
              The edited video file will be saved by the title below in the Asset manager.{' '}
            </small>
          </p>
          <div className="mt-2 w-100">
            <h6 className="font-bold" style={{ fontSize: '13px' }}>
              Page Title
            </h6>
            <CFormInput
              type="text"
              id="floatingInput"
              floatingLabel="Project title"
              placeholder="ex - Terms and Policy"
              className=" border border-start-0 border-end-0 border-top-0 rounded-0 border-bottom-2 shadow-none p-1 w-100"
              value={pageTitle}
              style={{ fontSize: '13px' }}
              onChange={(e) => titleChangeHandler(e.target.value)}
            />
            <div className={`d-flex justify-content-between w-100`}>
              <div className="message-text error-message">
                <p>{errorMsg?.pageTitle}</p>
              </div>
              <CFormText
                style={{ color: pageTitle.length < limit ? 'black' : 'red', fontSize: '12px' }}
              >
                Characters : {pageTitle.length}/{limit}
              </CFormText>
            </div>
          </div>
          <div className="mt-2 mb-5 w-100">
            <h6 style={{ fontSize: '13px' }} className="font-bold">
              Page URL
            </h6>
            <div className="d-flex align-items-center">
              <span style={{ fontSize: '13px' }} className="mr-3">
                /static/
              </span>
              <CFormInput
                type="text"
                id="pageUrl"
                placeholder="ex - business_directory"
                className=" border border-start-0 border-end-0 border-top-0 rounded-0 border-bottom-2 shadow-none p-1"
                value={pageUrl}
                style={{ fontSize: '13px' }}
                onChange={(e) => {
                  setErrorMsg((prev) => ({ ...prev, pageUrl: '' }))
                  setPageUrl(e.target.value.substring(0, limit))
                }}
              />
            </div>
            <div className={`d-flex justify-content-between w-100`}>
              <div className="message-text error-message">
                <p>{errorMsg?.pageUrl}</p>
              </div>
              <CFormText
                style={{ color: pageUrl.length < limit ? 'black' : 'red', fontSize: '12px' }}
              >
                Characters : {pageUrl.length}/{limit}
              </CFormText>
            </div>
          </div>
          <div className="d-flex flex-row-reverse">
            <CButton
              style={{ border: '1px solid black', fontSize: '.75rem' }}
              className="ml-2 bg-black rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onSaveHandler}
            >
              Proceed
            </CButton>
            <CButton
              style={{ color: 'black', border: '1px solid black', fontSize: '.75rem' }}
              className="mr-5 bg-white rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onCancel}
            >
              Cancel
            </CButton>
          </div>
        </div>
        <CImage src={DummyImg} width="55%" height="100%" fluid align="end" />
      </CModalBody>
    </CModal>
  )
}

export default StaticPageNameModal
